const SERVICE_GALLERIES = {
  "bathroom-remodeling": [
    {
      src: "https://images.unsplash.com/photo-1768413292551-10011d6c354e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxiYXRocm9vbSUyMHJlbW9kZWwlMjByZW5vdmF0aW9uJTIwdmFuaXR5JTIwdGlsZSUyMG1vZGVybnxlbnwwfHx8fDE3NzA2NTA2MDZ8MA&ixlib=rb-4.1.0&q=85",
      alt: "Full bathroom remodel in Albuquerque NM - modern vanity with blue tile and vessel sinks"
    },
    {
      src: "https://images.unsplash.com/photo-1765766600805-e75c44124d2c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwzfHxiYXRocm9vbSUyMHJlbW9kZWwlMjByZW5vdmF0aW9uJTIwdmFuaXR5JTIwdGlsZSUyMG1vZGVybnxlbnwwfHx8fDE3NzA2NTA2MDZ8MA&ixlib=rb-4.1.0&q=85",
      alt: "Luxury bathroom renovation New Mexico - marble and dark stone walk-in shower"
    },
    {
      src: "https://images.unsplash.com/photo-1761673271363-6efe71f08d18?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHw0fHxiYXRocm9vbSUyMHJlbW9kZWwlMjByZW5vdmF0aW9uJTIwdmFuaXR5JTIwdGlsZSUyMG1vZGVybnxlbnwwfHx8fDE3NzA2NTA2MDZ8MA&ixlib=rb-4.1.0&q=85",
      alt: "Complete bathroom remodeling Rio Rancho - bathtub shower and vanity installation"
    }
  ],
  "tub-shower-conversion": [
    {
      src: "https://images.unsplash.com/photo-1706670368974-af427a98e816?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHx0dWIlMjB0byUyMHNob3dlciUyMGNvbnZlcnNpb24lMjBiZWZvcmUlMjBhZnRlciUyMGJhdGhyb29tfGVufDB8fHx8MTc3MDY1MDU5Nnww&ixlib=rb-4.1.0&q=85",
      alt: "Tub to shower conversion Albuquerque - cultured marble walk-in shower with glass door"
    },
    {
      src: "https://images.unsplash.com/photo-1763485955499-f11dcfdda823?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHw0fHx0dWIlMjB0byUyMHNob3dlciUyMGNvbnZlcnNpb24lMjBiZWZvcmUlMjBhZnRlciUyMGJhdGhyb29tfGVufDB8fHx8MTc3MDY1MDU5Nnww&ixlib=rb-4.1.0&q=85",
      alt: "Shower to tub conversion New Mexico - luxury soaking tub with stone vanity"
    },
    {
      src: "https://images.unsplash.com/photo-1631048835379-c7f36f9410dd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHx3YWxrJTIwaW4lMjBzaG93ZXIlMjBnbGFzcyUyMGRvb3IlMjBtb2Rlcm4lMjBiYXRocm9vbXxlbnwwfHx8fDE3NzAzMTgwMzJ8MA&ixlib=rb-4.1.0&q=85",
      alt: "Walk-in shower installation Santa Fe - modern glass door tub to shower conversion"
    }
  ],
  "walk-in-tubs": [
    {
      src: "https://images.unsplash.com/photo-1636004482498-7b96b604a2ce?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBzb2FraW5nJTIwdHViJTIwZnJlZXN0YW5kaW5nJTIwYmF0aHR1YiUyMHNwYXxlbnwwfHx8fDE3NzAzMTgwNTl8MA&ixlib=rb-4.1.0&q=85",
      alt: "Walk-in tub installation Albuquerque NM - accessible bathtub with shower"
    },
    {
      src: "https://images.unsplash.com/photo-1575245122563-776ff6af7411?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHx3YWxrJTIwaW4lMjBiYXRodHViJTIwc2VuaW9yJTIwYWNjZXNzaWJsZSUyMHR1YnxlbnwwfHx8fDE3NzAzMTgwMzd8MA&ixlib=rb-4.1.0&q=85",
      alt: "Walk-in bathtub New Mexico - modern accessible tub for seniors"
    },
    {
      src: "https://images.unsplash.com/photo-1729173078273-3ee243b9273b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHw0fHxkZWVwJTIwc29ha2luZyUyMGJhdGh0dWIlMjBlbGVnYW50JTIwYmF0aHJvb20lMjByZWxheGluZ3xlbnwwfHx8fDE3NzAzMTgwNzN8MA&ixlib=rb-4.1.0&q=85",
      alt: "Soaking tub installation Rio Rancho - deep therapeutic walk-in bathtub"
    }
  ]
};

const defaultGalleryImages = SERVICE_GALLERIES["bathroom-remodeling"];

export const Gallery = ({ images = null, serviceType = "bathroom-remodeling" }) => {
  const galleryImages = images || SERVICE_GALLERIES[serviceType] || defaultGalleryImages;

  return (
    <section className="py-20 bg-white" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16 animate-fade-in">
          <span className="text-[#1E4C9A] font-semibold text-sm uppercase tracking-wider">
            Our Work
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mt-3 mb-4 font-['Playfair_Display']" data-testid="gallery-title">
            Recent Transformations in New Mexico
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            See the quality craftsmanship Prime Baths delivers to Albuquerque, Rio Rancho, Santa Fe, and surrounding areas.
          </p>
          <div className="section-divider mx-auto mt-4" />
        </div>

        {/* Gallery Grid */}
        <div className="grid md:grid-cols-3 gap-6">
          {galleryImages.map((image, index) => (
            <div
              key={index}
              className={`image-zoom rounded-xl overflow-hidden shadow-lg animate-slide-up delay-${(index + 1) * 100}`}
              data-testid={`gallery-image-${index}`}
            >
              <img
                src={image.src}
                alt={image.alt}
                title={image.alt}
                loading="lazy"
                className="w-full h-72 object-cover"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
